module.exports = __webpack_public_path__ + "static/media/RP-A_C_Embroidery_Bicocca_White_Bordeaux.f8c52e3f.png";